import { UPDATE_SITE } from "../actionTypes";

const initialState = {
  name: "",
  phone: "",
  address: "",
  contract: "",
  wechat: "",
  webSite: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_SITE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
}
